import { Fragment } from "react";

import { getCaseId, getClientId, getLoggedInFirmId } from "../../Utils/helper";
import { api_without_cancellation } from "../../api/api";

const SPACER_STYLE = { background: "white", width: "15px" };

const DocCell = ({ template, onClick = () => {} }) => (
  <div className="icon-text-boxes d-flex flex-wrap w-100 e-template-row height-25">
    <div
      className="col-12 col-md-3 col-xl icon-text-box text-center height-25 font-weight-semibold cursor-pointer btn-hover-document-row"
      id="no-vertical-border"
      style={{
        borderColor: "var(--primary)",
        backgroundColor: "var(--primary-10)",
        color: "var(--primary)",
        border: "1px solid var(--primary)",
      }}
      onClick={onClick}
    >
      <span
        className="icon-wrap m-r-5"
        style={{
          height: "15px",
          width: "15px",
          maxWidth: "15px",
          flex: "0 0 15px",
          margin: 0,
        }}
      >
        <i className="ic ic-15 ic-file-colored cursor-pointer" />
      </span>
      <p
        className="name"
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {template.template_name}
      </p>
    </div>
  </div>
);

/**
 * caseTypes: case types with embedded templates[]
 * onTemplateClick?: (template, caseType) => void
 */
const DocTable = ({ activeFirm, caseTypes = [] }) => {
  if (caseTypes.length === 0) return null;

  const columns = caseTypes.map((caseType) => ({
    ...caseType,
    docs: caseType.templates ?? [],
  }));

  const maxRows = Math.max(0, ...columns.map((col) => col.docs.length));
  const createEditDoc = async (docId, url, name, dynamic_template_id) => {
    try {
      const _currentUrl = window.location.href;

      const formData = new FormData();
      formData.append("doc_id", docId);
      formData.append("url", url);
      formData.append("name", name);
      formData.append("template_id", dynamic_template_id);

      const _response = await api_without_cancellation.post(
        `${origin}/api/create-edit-doc/`,
        formData
      );

      // Proceed with additional logic if needed
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const loggedinFirmID = getLoggedInFirmId();
  const onTemplateClick = async (template) => {
    if (Number(activeFirm?.firm_id) !== Number(loggedinFirmID)) return;
    const wp_url =
      "/bp-wordprocessor/" +
      getClientId() +
      "/" +
      getCaseId() +
      `/?docId=${template?.doc_id}&dynamic_template_id=${template?.id}&type=LetterTemplate`;
    await createEditDoc(template?.doc_id, wp_url, template?.template_name, template?.id);
    window.location.href = wp_url; // Change URL in the current tab
  };

  return (
    <div className="table--no-card rounded-0 border-0 w-100 m-t-5">
      <table
        className="table table-borderless table-earning"
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <thead className="sticked-head">
          <tr>
            <th style={SPACER_STYLE} />
            {columns.map((col) => (
              <Fragment key={col.id}>
                <th className="text-center">
                  <span
                    className="d-inline-flex align-items-center"
                    style={{
                      gap: "5px",
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col.casetype_icon && (
                      <img
                        src={col.casetype_icon}
                        alt=""
                        style={{ width: "15px", height: "15px" }}
                      />
                    )}
                    {col.name}
                  </span>
                </th>
                <th style={SPACER_STYLE} />
              </Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(maxRows)].map((_, rowIndex) => (
            <tr key={rowIndex}>
              <td style={SPACER_STYLE} />
              {columns.map((col) => {
                const template = col.docs[rowIndex];
                return (
                  <Fragment key={col.id}>
                    <td className="text-center">
                      {template && (
                        <DocCell
                          template={template}
                          onClick={() => onTemplateClick?.(template, col)}
                        />
                      )}
                    </td>
                    <td style={SPACER_STYLE} />
                  </Fragment>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DocTable;
